import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Restricted from '../views/Restricted.vue';
import Auth from "@aws-amplify/auth";
let user = null;


Vue.use(VueRouter)

const routes = [
  { path: '/', component: Login },
  {
    path: '/Restricted',
    component: Restricted,
    children: [
      {
        path: '/',
        name: 'Home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'CreateSite',
        name: 'CreateSite',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/CreateSite.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'CreateCamera',
        name: 'CreateCamera',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/CreateCamera.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ViewEvents',
        name: 'ViewEvents',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/ViewEvents.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ViewPictures',
        name: 'ViewPictures',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/ViewPictures.vue'),
        meta: {
          requiresAuth: true
        }
      },      
      {
        path: 'AuditLog',
        name: 'AuditLog',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AuditLog.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'Profile',
        name: 'Profile',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'Logout',
        name: 'Logout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Logout.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      user = await Auth.currentAuthenticatedUser();
      if (!user) {
        next({
          path: "/"
        });
      } else {
        next()
      }
    } catch (e) {
      next({
        path: "/"
      });
    }
  }
  next();
});


export default router
